import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import {Grid} from '@material-ui/core';
import { formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/util';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import DividerCustom from '../../components/Divider'
import InfiniteScroll from 'react-infinite-scroll-component';
const drawerWidth = 520;
const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(3,4,3,4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    },
    item:{
        padding: theme.spacing(0,0,2,0),
    },
    listItem: {
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(1),
        backgroundColor:theme.palette.background.secondary
    },

    image_bg: {
        width: 40,
        height: 40,
        borderRadius: 40,
        backgroundColor: theme.palette.background.transparent
    },
    image: {
        width: 40,
        height: 40,
        resizeMode: 'contain'
    },

    status:{
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        ...theme.palette.button.danger,
    },
    statusAdHoc:{
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        backgroundColor: theme.palette.background.other,
        color: theme.palette.text.onPrimary,
    }, 
    box:{
        padding: theme.spacing(2,2,0,2)
    } 
});

function TransactionsView(props) {
    const { classes, t, transactions, currency, handleLoadMore, showLoadMore, hasMore, showLoading } = props;
    //console.log('transaction item= ', transactions)
    //console.log("profile======== ", profileName)
    return (
        <div>
                <DrawerCustom
                    open={props.open}
                    onClose={()=>props.handleDrawerOtherToggle('transactions')}
                    title = {t('rewards_transactions')}
                    children={
                        <Grid item>
                            <Grid item container justify='center' alignItems='center'>
                                {showLoading&&<CustomizedCircularProgress/>}
                            </Grid>
                            {transactions&&<Grid xs={12} item>
                                <InfiniteScroll
                                    dataLength={transactions.length} //This is important field to render the next data
                                    next={handleLoadMore}
                                    hasMore={hasMore}
                                    loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                                    height={window.innerHeight}
                                    >
                                    <Grid xs={12} item>
                                        {transactions.map((item,index)=><TransactionItem classes={classes} key ={index} 
                                                                                            item = {item} currency={currency} 
                                                                                            onClickDetail={props.onClickDetail}
                                                                                            transactionDetail={props.transactionDetail}
                                                                                            showDetail={props.showDetail}/>
                                        )}
                                    </Grid>
                                </InfiniteScroll>
                            </Grid>}
                    </Grid>
                    }/>

        </div>
    );
}

function TransactionItem(props){
    const {item, classes, currency} = props
    //console.log('props.transactionDetail===',props.transactionDetail)
    //console.log('TransactionItemitem===',item)
    var showDetail = props.showDetail&&props.transactionDetail&&props.transactionDetail.id&&props.transactionDetail.id===item.id;
    var rewards = item.rewards;
    var fees = item.fees;

    // item.ad_hoc_return = {
    //     amount: 100,
    //     return_amount: 200,
    // }
    // item.ad_hoc_return_date = item.performed_on
    return(
        <div>
        <Grid xs={12} item container className={classes.boxItemContent} onClick={()=>props.onClickDetail(item)}>
            <Grid xs={12} item container direction='row'>
                <Grid item xs={6}>
                    <CustomTypo mg_top_sm variant='body2' color='secondary'>{item.performed_on ? formatDateToDDMMYYYYHHSSFrEpoch(item.performed_on) : ""}</CustomTypo> 
                </Grid>
                
                <Grid item xs={6} container justify='flex-end' >
                {item.ad_hoc_return?<Grid item className={classes.statusAdHoc}>
                    <CustomTypo variant='body2' center>{'AD HOC RETURN'}</CustomTypo>
                </Grid>:null}
                {item.life_cycle_state === "CANCELLED"?<Grid item className={classes.status}>
                    <CustomTypo variant='body2' center>{item.life_cycle_state}</CustomTypo>
                </Grid>:null}
            </Grid>
            </Grid>

            <Grid xs={12} item container alignItems='center'>
                        <Grid xs={12} item>
                            <CustomTypo variant='subtitle2'>{item.performed_by_organisation ? item.performed_by_organisation.name : ""}</CustomTypo>
                        </Grid>
                    <Grid xs={12} item container direction='row'>
                        <Grid xs={3} item container justify='center'>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo >{currency}{item.total_amount ? item.total_amount.toFixed(2) : "0.00"}</CustomTypo>
                            </Grid>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo variant='body2'>{t('purchase_amount')}</CustomTypo>
                            </Grid>
                        </Grid>
                        {rewards.total_instant_discount_amount ? <Grid xs={6} item container>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo color='success'>{currency}{rewards.total_instant_discount_amount ? rewards.total_instant_discount_amount.toFixed(2): "0.00"}</CustomTypo>
                            </Grid>
                                <Grid xs={12} item container justify='center'>
                                    <CustomTypo variant='body2'>{t('discount_amount')}</CustomTypo>
                                </Grid>
                        </Grid> : null}
                        {!rewards.total_instant_discount_amount ? <Grid xs={6} item container>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo color='success'>{currency}{rewards.total_award_amount ? rewards.total_award_amount.toFixed(2): "0.00"}</CustomTypo>
                            </Grid>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo variant='body2'>{t('award_amount')}</CustomTypo>
                            </Grid>
                        </Grid>:null}
                        {!rewards.total_instant_discount_amount && rewards.total_spend_amount ?<Grid xs={3} item container justify='flex-end'>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo color='danger'>{currency}{rewards.total_spend_amount.toFixed(2)}</CustomTypo>
                            </Grid>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo variant='body2'>{t('spend_amount')}</CustomTypo>
                            </Grid>
                        </Grid>:null}
                    </Grid>
            </Grid>
            {showDetail&&<Grid item xs={12} className={classes.box}>
                <Grid item xs={12}>
                    <CustomTypo variant='button'>{ t('rewards_breakdown')}</CustomTypo>
                </Grid>
                {rewards.total_award_amount>0&&<Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('total_award_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{rewards.total_award_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>}
                {rewards.total_spend_request_amount>0&&<Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('spend_on_request_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{rewards.total_spend_request_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>}
                {rewards.total_instant_discount_amount>0&&<Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('instant_discount_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{rewards.total_instant_discount_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>}
                {rewards.total_automatic_spend_amount>0&&<Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('automatic_spend_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{rewards.total_automatic_spend_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>}
            </Grid>}

            {showDetail&&<Grid item xs={12} className={classes.box}>
                <Grid item xs={12}>
                    <CustomTypo variant='button'>{ t('applied_fees')}</CustomTypo>
                </Grid>
                <Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('total_fee_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{fees.total_fee_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>
                <Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('fee_on_awards')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{fees.wallet_credit_fee_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>
                <Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('fee_on_spend')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{fees.wallet_debit_fee_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>
            </Grid>}

            {showDetail&&item.ad_hoc_return&&<Grid item xs={12} className={classes.box}>
                <Grid item xs={12}>
                    <CustomTypo variant='button'>{t('ad_hoc_return')}</CustomTypo>
                </Grid>
                <Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('requested_return_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{item.ad_hoc_return.amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>
                <Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('actual_return_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{currency}{item.ad_hoc_return.return_amount.toFixed(2)}</CustomTypo>
                    </Grid>
                </Grid>
                <Grid item xs={12} container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo variant='description'>{t('requested_on')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='description'>{item.ad_hoc_return.ad_hoc_return_date ? formatDateToDDMMYYYYHHSSFrEpoch(item.ad_hoc_return.ad_hoc_return_date) : ""}</CustomTypo>
                    </Grid>
                </Grid>
            </Grid>}
        </Grid>

        </div>
    )
}
export default withStyles(styles)(withTranslation()(TransactionsView));